export const AccessConfigData = {
    "maxLineLimit": 25001,
    "maxFileSize": 10,
    "headerMismatchErrorMsg": "Specified headers dont match",
    "maxRowsErrorMsg": "Max number of rows allowed is ",
    "existingSitenameError": "existingSitenameError",
    "assignedSitenameError": "assignedSitenameError",
    "existingRecordsModify": "existingRecordsModify",
    "locationFriendlyNameError": "locationFriendlyNameError",
    "assetNameError": "assetNameError",
    "existingRecordsDeleteError": "existingRecordsDeleteError",
    "matchFileType": true,
    "checkDataType": false,
    "matchHeader": true,
    "rowMisMatchError": "Error on row",
    "knownObj": [
        {
            "headerName": "BSSID",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "AssetName",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "LocationFriendlyName",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "SiteName",
            "headerType": "string",
            "maxLength": 32
        }
    ]
}
